import axios from 'axios'

export default {
    // Módulos
    getModulos() {
        return axios.get('/suscripciones/modulos/')
    },

    // Features
    getFeatures() {
        return axios.get('/suscripciones/features/')
    },

    // Planes
    getPlanes() {
        return axios.get('/suscripciones/planes/')
    },
    createPlan(data) {
        return axios.post('/suscripciones/planes/', data)
    },
    updatePlan(id, data) {
        return axios.patch(`/suscripciones/planes/${id}/`, data)
    },
    deletePlan(id) {
        return axios.delete(`/suscripciones/planes/${id}/`)
    },

    // Suscripciones
    getSuscripciones() {
        return axios.get('/suscripciones/suscripciones/')
    },
    createSuscripcion(data) {
        return axios.post('/suscripciones/suscripciones/', data)
    },
    updateSuscripcion(id, data) {
        return axios.patch(`/suscripciones/suscripciones/${id}/`, data)
    },
    deleteSuscripcion(id) {
        return axios.delete(`/suscripciones/suscripciones/${id}/`)
    },

    // Para el frontend de empresa
    getMisModulos() {
        return axios.get('/suscripciones/mis-modulos/')
    },

    // ─── Facturación del SaaS ──────────────────────────────────────────────

    // Servicios adicionales (catálogo)
    getServicios() {
        return axios.get('/suscripciones/servicios/')
    },
    createServicio(data) {
        return axios.post('/suscripciones/servicios/', data)
    },
    updateServicio(id, data) {
        return axios.patch(`/suscripciones/servicios/${id}/`, data)
    },
    deleteServicio(id) {
        return axios.delete(`/suscripciones/servicios/${id}/`)
    },

    // Servicios contratados por una empresa
    getServiciosContratados(suscripcionId) {
        return axios.get('/suscripciones/servicios-contratados/', {
            params: suscripcionId ? { suscripcion: suscripcionId } : {},
        })
    },
    createServicioContratado(data) {
        return axios.post('/suscripciones/servicios-contratados/', data)
    },
    deleteServicioContratado(id) {
        return axios.delete(`/suscripciones/servicios-contratados/${id}/`)
    },

    // Cuenta por empresa (overview de lo que debe cada una)
    getCuentaEmpresas() {
        return axios.get('/suscripciones/resumenes/cuenta-empresas/')
    },

    // Resúmenes mensuales
    getResumenes(params = {}) {
        return axios.get('/suscripciones/resumenes/', { params })
    },
    getResumen(id) {
        return axios.get(`/suscripciones/resumenes/${id}/`)
    },
    generarResumenes(data) {
        return axios.post('/suscripciones/resumenes/generar/', data)
    },
    emitirResumen(id, data = {}) {
        return axios.post(`/suscripciones/resumenes/${id}/emitir/`, data)
    },
    anularResumen(id) {
        return axios.post(`/suscripciones/resumenes/${id}/anular/`, {})
    },
    reabrirResumen(id) {
        return axios.post(`/suscripciones/resumenes/${id}/reabrir/`, {})
    },
    pagarResumen(id, data) {
        return axios.post(`/suscripciones/resumenes/${id}/pagar/`, data)
    },
    getResumenPdf(id) {
        return axios.get(`/suscripciones/resumenes/${id}/pdf/`, { responseType: 'blob' })
    },
    getReciboPdf(pagoId) {
        return axios.get(`/suscripciones/pagos/${pagoId}/pdf/`, { responseType: 'blob' })
    },
    updatePago(pagoId, data) {
        return axios.patch(`/suscripciones/pagos/${pagoId}/`, data)
    },
    anularPago(pagoId, motivo) {
        return axios.post(`/suscripciones/pagos/${pagoId}/anular/`, { motivo })
    },
    deleteResumen(id) {
        return axios.delete(`/suscripciones/resumenes/${id}/`)
    },

    // Líneas extra de un resumen (servicio o producto suelto)
    createLinea(data) {
        return axios.post('/suscripciones/lineas/', data)
    },
    deleteLinea(id) {
        return axios.delete(`/suscripciones/lineas/${id}/`)
    },

    // Solicitudes de cambio que llegan desde "Mi plan" (admin)
    getSolicitudes(params = {}) {
        return axios.get('/suscripciones/solicitudes/', { params })
    },
    atenderSolicitud(id, respuesta = '') {
        return axios.post(`/suscripciones/solicitudes/${id}/atender/`, { respuesta })
    },
    descartarSolicitud(id, respuesta = '') {
        return axios.post(`/suscripciones/solicitudes/${id}/descartar/`, { respuesta })
    },

    // "Mi plan" (empresa)
    getMiPlan() {
        return axios.get('/suscripciones/mi-plan')
    },
    solicitarCambio(data) {
        return axios.post('/suscripciones/mi-plan/solicitudes', data)
    },
    getMiResumenPdf(id) {
        return axios.get(`/suscripciones/mi-plan/resumenes/${id}/pdf`, { responseType: 'blob' })
    },
    getMiReciboPdf(pagoId) {
        return axios.get(`/suscripciones/mi-plan/recibos/${pagoId}/pdf`, { responseType: 'blob' })
    },
}
